export default "__VITE_ASSET__DarYG2yD__"